import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import {
  fetchProfilesSuggestionsError,
  fetchProfilesSuggestionsSuccess,
  getPreviewError,
  getPreviewSuccess,
  testScenarioError,
  testScenarioSuccess,
} from './actions'
import {
  FETCH_PROFILES_SUGGESTIONS_ASYNC,
  GET_PREVIEW_ASYNC,
  TEST_SCENARIO_ASYNC,
} from './constants'

const getPreviewEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_PREVIEW_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .previewScenario(
          action.payload.id,
          action.payload.locale,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) => getPreviewSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getPreviewError, error, [400]))),
          takeUntil(action$.pipe(ofType(GET_PREVIEW_ASYNC.CANCEL)))
        )
    )
  )

const fetchProfilesSuggestionsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_PROFILES_SUGGESTIONS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.mailboxes
        .getEmails(state$.value.partnerOptions.selectedCompany?.value, action.payload.search, false)
        .pipe(
          map((response) => fetchProfilesSuggestionsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(fetchProfilesSuggestionsError, error))),
          takeUntil(action$.pipe(ofType(FETCH_PROFILES_SUGGESTIONS_ASYNC.CANCEL)))
        )
    )
  )

const testScenarioEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(TEST_SCENARIO_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .testScenario(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.id,
          action.payload.locale,
          action.payload.values,
          action.payload.deliveryType
        )
        .pipe(
          map(({ response }) => testScenarioSuccess(response)),
          catchError((error) => of(epicsErrorHandler(testScenarioError, error))),
          takeUntil(action$.pipe(ofType(TEST_SCENARIO_ASYNC.CANCEL)))
        )
    )
  )
export default combineEpicsIsolated(getPreviewEpic, fetchProfilesSuggestionsEpic, testScenarioEpic)
